<template>
  <v-app>
    <v-main>
      <v-container>
        <v-card>
          <v-card-title id="menuHolder">
            <v-spacer></v-spacer>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :disabled="loading"
              :return-value.sync="earliestDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
              attach="#menuHolder"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="earliestDate"
                  clearable
                  hide-details
                  label="Select Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  style="max-width: 290px; margin-right: 1em;"
                ></v-text-field>
              </template>
              <v-date-picker v-model="earliestDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(earliestDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            &nbsp;
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            color="#ee6301"
            :headers="headers"
            :header-props="{ color: '#ee6301' }"
            :items="filtered"
            :fixed-header="true"
            :items-per-page="10"
            :loading="loading"
          >
            <template v-slot:item.displayTitle="{ item }">
              <v-skeleton-loader v-if="loading" type="text"></v-skeleton-loader>
              <div v-else class="py-2">
                <a
                  :href="`https://my.osufst.org/courses/${item.course_id}`"
                  target="_blank"
                  class="course-title"
                >
                  {{ item.title }}
                </a>
                <div v-if="!item.events || item.events.length === 0" class="d-sm-none">
                  <span>Contact Course Director</span>
                </div>
                <div v-for="event in item.events" v-bind:key="event.id" class="d-sm-none pt-2">
                  <span>{{ event.locationName }}</span><br />
                  <span>{{ formatDate(event.starts_at) }}</span><br />
                  <span>{{ formatSeats(event.seatsOpen) }}</span>
                </div>
              </div>
            </template>

            <template v-slot:item.displayLocation="{ item }">
              <v-skeleton-loader v-if="!item.events" type="text"></v-skeleton-loader>
              <span
                v-else-if="item.events.length > 0"
                style="white-space: nowrap;"
                v-html="item.events.map(e => e.locationName).join('<br />')"
                class="hidden-xs-only"
              ></span>
              <span
                v-else
                style="white-space: nowrap;"
                class="hidden-xs-only"
              >
                Contact Course Director
              </span>
            </template>

            <template v-slot:item.displayDate="{ item }">
              <v-skeleton-loader v-if="!item.events" type="text"></v-skeleton-loader>
              <span
                v-else
                style="white-space: nowrap;"
                v-html="item.events.map(e => formatDate(e.starts_at)).join('<br />')"
                class="hidden-xs-only"
              >
              </span>
            </template>

            <template v-slot:item.displaySeats="{ item }">
              <v-skeleton-loader v-if="!item.events" type="text"></v-skeleton-loader>
              <span
                v-else
                style="white-space: nowrap;"
                v-html="item.events.map(e => {
                  const openSeats = e.seatsOpen;
                  if (openSeats < 1) return 'Contact FST';
                  return openSeats;
                }).join('<br />')"
                class="hidden-xs-only"
              >
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',

  computed: {
    filtered() {
      if (!this.earliestDate && !this.search) return this.courses;
      const filteredCourses = JSON.parse(JSON.stringify(this.courses));
      filteredCourses.forEach(c => {
        if (this.earliestDate) {
          c.events = c.events.filter(e => e.starts_at >= this.earliestDate);
        }
        if (this.search) {
          c.events = c.events.filter(e => c.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 || e.locationName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
        }
      });
      return filteredCourses.filter(c => c.events.length > 0 || c.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },
    ...mapState({
      courses: state => state.courses,
    }),
  },

  data: () => ({
    earliestDate: null,
    headers: [
      { text: 'Course Name', value: 'displayTitle', class: 'title', sortable: false, },
      { text: 'Location', value: 'displayLocation', class: 'title', sortable: false, },
      { text: 'Date', value: 'displayDate', class: 'title', sortable: false, },
      { text: 'Seats Available', value: 'displaySeats', class: 'title', sortable: false, },
    ],
    loading: true,
    menu: false,
    search: '',
    tags: null,
    unit: null,
  }),

  async created() {
    this.tags = vueData.tags;
    this.unit = vueData.unit.indexOf(',') != -1 ? vueData.unit.split(',') : vueData.unit;
    await this.$store.dispatch('fetchCourses', { tags: this.tags, unitIds: this.unit, nonce: vueData.nonce });
    this.loading = false;
  },

  methods: {
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleString('en-US', {
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        month: 'short',
        timeZoneName: 'short',
        weekday: 'short',
        year: 'numeric',
      });
    },
    formatSeats(openSeats) {
      if (openSeats < 1) return 'Contact FST';
      if (openSeats === 1) return '1 seat available';
      return `${openSeats} seats available`;
    },
  }
};
</script>

<style lang="css">
.v-data-table__mobile-row__header {
  display: none;
}
.v-application .v-data-table__mobile-row__cell {
  text-align: left !important;
}
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
  min-height: 0 !important;
  height: auto !important;
}
</style>
